import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const NotificationsRedux = createActions(
  {
    // Custom actions
    updateNotificationsRequest: ['studentId', 'activeNotifications'],
    updateNotificationsSuccess: ['response'],
    updateNotificationsError: ['error'],
    updateParentNotificationsRequest: ['studentId', 'activeNotifications'],
    updateParentNotificationsSuccess: ['response'],
    updateParentNotificationsError: ['error'],
  },
  {
    prefix: 'NOTIFICATIONS_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = NotificationsRedux
export const NotificationsTypes = Types
export default Creators

export const INITIAL_STATE = createState({
// custom state
  updateResponse: {},
  sending: {
    fetching: false,
  }
},
{
  get: true,
  // Default state
})

const updateNotificationsRequest = state => state.merge({ get: { fetching: true, error: null } }, d)
const updateNotificationsSuccess = (state, { response }) =>
  state.merge({ get: { fetching: false }, updateResponse: response }, d)
const updateNotificationsError = (state, { error }) =>
  state.merge({ get: { fetching: false, error } }, d)

const updateParentNotificationsRequest = state => state.merge({ get: { fetching: true, error: null },
  sending: {
    fetching: true,
  } }, d)
const updateParentNotificationsSuccess = (state, { response }) =>
  state.merge({ get: { fetching: false },
    updateResponse: response,
    sending: {
      fetching: false,
    } }, d)
const updateParentNotificationsError = (state, { error }) =>
  state.merge({ get: { fetching: false, error },
    sending: {
      fetching: false,
    } }, d)

export const reducer = createReducer(
  INITIAL_STATE, {
    // custom reducers
    [Types.updateNotificationsRequest]: updateNotificationsRequest,
    [Types.updateNotificationsSuccess]: updateNotificationsSuccess,
    [Types.updateNotificationsError]: updateNotificationsError,
    [Types.updateParentNotificationsRequest]: updateParentNotificationsRequest,
    [Types.updateParentNotificationsSuccess]: updateParentNotificationsSuccess,
    [Types.updateParentNotificationsError]: updateParentNotificationsError,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/NotificationsRedux.js